/* eslint-disable */
<template>
  <footer class="site-footer">
    <div class="footer-inner" @click="scrollToTop()">

      <div class="footer-left">
        <div class="footer-gov-badge">LG</div>
        <div class="footer-info">
          <span class="footer-title">Local Government Online Payment System</span>
          <span class="footer-copy">© {{ new Date().getFullYear() }} Ministry of Public Administration, Home Affairs, Provincial Councils &amp; Local Government</span>
        </div>
      </div>

      <div class="footer-right">
        <button class="back-top-btn" @click.stop="scrollToTop()" title="Back to top">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7"/>
          </svg>
          <span>Top</span>
        </button>
      </div>

    </div>
  </footer>
</template>


<script>
import { mapState } from 'vuex';
export default {
  name: 'FooterComponent',
  computed: {
    ...mapState(['user'])
  },
  methods: {
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
};
</script>


<style scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,400;9..40,500&family=DM+Serif+Display&display=swap');

* { box-sizing: border-box; }

.site-footer {
  background: linear-gradient(135deg, #7c2d12 0%, #9a3412 60%, #c2440a 100%);
  font-family: 'DM Sans', sans-serif;
  border-top: 3px solid rgba(255,255,255,0.1);
}

.footer-inner {
  max-width: 1100px;
  margin: 0 auto;
  padding: 1.6rem 4%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
  flex-wrap: wrap;
  cursor: pointer;
}

/* ── Left ── */
.footer-left {
  display: flex;
  align-items: center;
  gap: 1.2rem;
}

.footer-gov-badge {
  width: 4rem; height: 4rem;
  border-radius: 50%;
  background: rgba(255,255,255,0.15);
  border: 1.5px solid rgba(255,255,255,0.3);
  color: #fff;
  font-family: 'DM Serif Display', serif;
  font-size: 1.3rem; font-weight: 700;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}

.footer-info {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.footer-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #fff;
  letter-spacing: 0.01em;
}

.footer-copy {
  font-size: 1.05rem;
  color: rgba(255,255,255,0.65);
  line-height: 1.4;
}

/* ── Right ── */
.back-top-btn {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 0.2rem;
  padding: 0.6rem 1.1rem;
  background: rgba(255,255,255,0.12);
  border: 1px solid rgba(255,255,255,0.22);
  border-radius: 0.7rem;
  color: #fff;
  font-family: 'DM Sans', sans-serif;
  font-size: 1.05rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}
.back-top-btn svg { width: 1.6rem; height: 1.6rem; stroke: #fff; }
.back-top-btn:hover {
  background: rgba(255,255,255,0.25);
  border-color: rgba(255,255,255,0.4);
  transform: translateY(-2px);
}

/* ── Responsive ── */
@media (max-width: 600px) {
  .footer-inner { flex-direction: column; align-items: flex-start; gap: 1.2rem; padding: 1.4rem 5%; }
  .footer-right { align-self: flex-end; }
}
</style>